import VueTelInput from 'vue-tel-input'
import Vue from 'vue'

Vue.use(VueTelInput, {
    autocomplete: "false",
    autofocus: true,
    inputClasses: "",
    wrapperClasses: "v-input__control"
        // ["v-input",
        // "v-text-field",
        // "v-text-field--single-line",
        // "v-text-field--solo",
        // "v-text-field--enclosed",
        // "v-text-field--placeholder",
        // "theme--light"]

})
